import Vue from "vue";

import vuexI18n from "vuex-i18n";
import store from "./store";

Vue.use(vuexI18n.plugin, store);

import en from "@/lang/en.json";
import ja from "@/lang/ja.json";

Vue.i18n.add("en", en);
Vue.i18n.add("ja", ja);

Vue.i18n.set(store.state.lang);
